<template>
    <div v-if="whiteBrandDomains.some(d => domain.includes(d))" class='white_dns'>
        <v-card 
            color="#F2F1FF"
            elevation="0" 
            max-width="450"                             
            class="mx-auto pa-5 rounded-xl card__signup__form" 
            :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
        >                            
            <v-card-title class="justify-center login__form__title" :style="{ color: $vuetify.theme.themes.light.primary }">
                <h1>Inicio de sesión</h1>
            </v-card-title>
            <v-card-text class="pb-2">
                <v-form>
                    <v-text-field
                        solo 
                        flat
                        v-model="username"
                        name="username"
                        label="Usuario"
                        background-color="white"
                        prepend-inner-icon="mdi-account-circle"
                        class="login__form__field"
                    />
                    <v-text-field
                        solo
                        flat
                        elevation="0"                                        
                        v-model="password"
                        name="password"
                        label="Contraseña"
                        background-color="white"
                        prepend-inner-icon="mdi-lock"
                        class="login__form__field"
                        :type="showPassword ? 'text' : 'password'"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                        v-on:keyup.enter="login"
                    />
                    <p v-if="error" class="red--text">{{error}}</p>
                </v-form>
            </v-card-text>
            <v-card-actions class="justify-center">
                <!--<v-btn color="success">Register</v-btn>-->
                <v-btn
                    x-large
                    rounded
                    elevation="0"
                    color="#2DC4F7"
                    class="white--text px-6 text-none font-weight-bold"
                    :loading='loading'
                    @click="login"
                >
                    INICIAR SESIÓN
                </v-btn>
            </v-card-actions>
            <v-card-text class="text-center">
                <router-link :to="{ name: 'password-reset' }">
                    ¿Has olvidado tu contraseña?
                </router-link>                                    
            </v-card-text>
        </v-card>
    </div>
    <div v-else class="content-style">
    
        <app-header-public :transparentHeader="true" v-if="!hasWhiteBrand"/>
        <section id="login" :class="!hasWhiteBrand ? 'hero__login': 'login'" >        
            <v-container fluid :class="!hasWhiteBrand ? 'd-flex align-center hero__login__container' : 'd-flex align-center login__container'">                                                     
                <v-row>
                    
                    <v-col v-if="!hasWhiteBrand"
                        class="login__column login__news__column"
                        :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12"
                        :order="$vuetify.breakpoint.mdAndDown ? 'last' : 'first'"
                    >
                        <v-card-title :class="$vuetify.breakpoint.mdAndDown ? 'justify-center' : ''">
                            <h2 class="login__news__title white--text">
                                Bienvenido de nuevo
                            </h2>
                        </v-card-title>
                        <v-card-text tag="article">
                            <p class="login__news__article__text white--text">
                                Descubre cómo podemos ayudarte aún más. Optimiza tus procesos con nuestras soluciones integradas.
                            </p>
                            <p class="login__news__article__header white--text">
                                &nbsp;<b>Gestor Documental</b>: Sube, comparte y organiza documentos. Automatiza flujos de trabajo y notificaciones.
                            </p>
                            <p class="login__news__article__header white--text">
                                &nbsp;<b>Bancos</b>: Concilia automáticamente extractos bancarios, crea reglas personalizadas y envía asientos contables.
                            </p>
                            <p class="login__news__article__text white--text">Accede a tu cuenta y explora las posibilidades.</p>
                            <!--
                            <h2 class="login__news__article__header white--text" :class="$vuetify.breakpoint.mdAndDown ? 'text-center' : ''">
                                Nuevo módulo de conciliación bancaria con Inteligencia Artificial (IA)
                            </h2>
                            <p class="login__news__article__text white--text">
                                Inmatic ha sacado un nuevo módulo donde podrás subir movimientos bancarios sin necesidad de tener las credenciales bancarias de tus clientes, crearás reglas automáticas con Inteligencia Artificial y conciliarás los movimientos automáticamente.
                            </p>
                            <p class="login__news__article__text white--text">
                                ¡Solicítanos la activación y pruébalo sin compromiso!
                            </p>
                            -->
                            <div v-if="$vuetify.breakpoint.lgAndUp" class="login__news__article__spacing-hack" />
                        </v-card-text>
                        
                    </v-col>
                    <v-col v-else
                        elevation="0" 
                        max-width="450"                             
                        class="mx-auto pa-5 text-center logo__login" 
                        :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
                        :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12"
                        :order="$vuetify.breakpoint.mdAndDown ? 'last' : 'first'"
                    >
                        <img :src="whiteBrandLogoURL" alt="White brand logo">
                    </v-col>
                    <v-col
                        :cols="$vuetify.breakpoint.lgAndUp ? 6 : 12"
                        class="login__column login__form__column"
                    >
                        <v-card 
                            color="#F2F1FF"
                            elevation="0" 
                            max-width="450"                             
                            class="mx-auto pa-5 rounded-xl card__signup__form" 
                            :class="{'mt-5': $vuetify.breakpoint.smAndUp}"
                        >                            
                            <v-card-title class="justify-center login__form__title" :style="{ color: $vuetify.theme.themes.light.primary }">
                                <h1>Inicio de sesión</h1>
                            </v-card-title>
                            <v-card-text class="pb-2">
                                <v-form>
                                    <v-text-field
                                        solo 
                                        flat
                                        v-model="username"
                                        name="username"
                                        label="Usuario"
                                        background-color="white"
                                        prepend-inner-icon="mdi-account-circle"
                                        class="login__form__field"
                                    />
                                    <v-text-field
                                        solo
                                        flat
                                        elevation="0"                                        
                                        v-model="password"
                                        name="password"
                                        label="Contraseña"
                                        background-color="white"
                                        prepend-inner-icon="mdi-lock"
                                        class="login__form__field"
                                        :type="showPassword ? 'text' : 'password'"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="showPassword = !showPassword"
                                        v-on:keyup.enter="login"
                                    />
                                    <p v-if="error" class="red--text">{{error}}</p>
                                </v-form>
                            </v-card-text>
                            <v-card-actions class="justify-center">
                                <!--<v-btn color="success">Register</v-btn>-->
                                <v-btn
                                    x-large
                                    rounded
                                    elevation="0"
                                    color="#2DC4F7"
                                    class="white--text px-6 text-none font-weight-bold"
                                    :loading='loading'
                                    @click="login"
                                >
                                    INICIAR SESIÓN
                                </v-btn>
                            </v-card-actions>
                            <v-card-text class="text-center">
                                <router-link :to="{ name: 'password-reset' }">
                                    ¿Has olvidado tu contraseña?
                                </router-link>                                    
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                   
            
            </v-container>
        </section>            
        <app-footer-public/>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import AppHeaderPublic from "@/components/layout/AppHeaderPublic";
import AppFooterPublic from "@/components/layout/AppFooterPublic";
import { GetWhiteBrandLogo } from "@/modules/accounts/app/GetWhiteBrandLogo";

export default {
    name: 'LoginPage',
    components: {
        AppHeaderPublic,
        AppFooterPublic
    },
	data() {
		return {
			showPassword: false,
			username:'',
			password:'',
			error: '',
			loading: false,
            whiteBrandLogoURL: undefined,
            hasWhiteBrand:true,
            domain: window.location.origin,
            whiteBrandDomains: [
                'docuxtract.docunecta.com',
                'gscan.glasof.com',
                'portal.oxigendc.com',
                'app.novantiaeconomistas.es',
                'app.gestoriamoro.com'
            ],
           
		}
	},
    metaInfo() {
        return {
            title: this.pageTitle(),
            titleTemplate: null,
            meta: [
                {name: 'description', content: 'Inicia sesión con tu cuenta de Inmatic. Contabiliza automáticamente tus facturas y empieza a ser más productivo.'},
                {name: 'robots', content: 'noindex'},
            ],  
        }
    },
	computed: {
		...mapState([
			'currentCompany',
		]),

        logoClasses() {
            let classes = 'mx-auto'

            if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.sm) {
                classes += ' my-12'
            } else if (this.$vuetify.breakpoint.xs) {
                classes += ' mt-6 mb-0'
            }
            
            return classes
        },
        
  	},
    
    async mounted() {
        if(this.$route.name=='white_brand') {
            let url = location.pathname.split('/');
            await new GetWhiteBrandLogo(this).run(url[1])
        } else {
            this.hasWhiteBrand = false
        }
    },

    methods: {
        pageTitle() {
            // window.location.origin.includes('docuxtract.docunecta.com') || window.location.origin.includes('gscan.glasof.com')
            if (this.whiteBrandDomains.some(d => this.domain.includes(d))) {
                return 'Iniciar sesión'
            } else {
                return 'Iniciar sesión - Inmatic'
            }
        },
        mostrarHeader(){
            if (this.$route.name=='white_brand'){
                return false
            }

            return true;
        },
        async login() {
            this.loading = true;
            this.error = '';
            if (Boolean(this.username) && Boolean(this.password)) {
                try {
                    const result = await this.signInUser({
                        username: this.username,
                        password: this.password
                    });
                    this.setJWTToken(result);
                    this.setAfterLogged().then(() => {
                        if (this.currentCompany) {
                            // this.$router.push(this.currentCompany.id + "/documents");
                            this.$router.push({
                                name: 'document-list',
                                params: { companydb_id: this.currentCompany.id },
                            });
                        } else {
                            this.$router.push("/initial");
                        }
                    }).catch(err => {
                        console.error(err);
                        if (err && err.response && err.response.status == 401) {
                            this.error = 'Usuario no autorizado.';
                            this.loading = false;
                        }
                        else {
                            this.$router.push("documents");
                        }
                    });
                } catch (error) {             
                    if (error.code == 'UserNotFoundException') {
                        this.error = 'El usuario no existe.'
                    } else if (error.code == 'InvalidParameterException' || error.code == 'NotAuthorizedException') {
                        this.error = 'Nombre de usuario o contraseña incorrectos.';
                    } else {
                        this.error = error.message;
                    }
                    this.loading = false;
                }
            } else {
                this.error = 'El nombre de usuario y la contraseña son obligatorios.';
                this.loading = false;
            }
        },
        ...mapActions(["signInUser", "setJWTToken", "setAfterLogged"]),

        
    },
    
}
</script>

<style scoped>
.content-style {  
    height: 100%;
    margin-top:-140px;
}
.hero__login {
    background-image: url('/inmatic_bg_nohand.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position:relative;
    min-height: 100vh;
    width:"100vw";
}
.hero__login .hero__login__container {
    padding-top: 150px;
    padding-bottom: 160px;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 100vh;
}
.login {
    background-color:white;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position:relative;
    min-height: 100vh;
    width:100%;
}
.login .login__container {
    padding-top: 150px;
    padding-bottom: 50px;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 100vh;
}

.logo__login {
    display: flex;
    justify-content: center;
}

.logo__login img {
    vertical-align: middle;
    height: 50%;
    margin: auto;
}



.login__column {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
}

.login__loudspeaker {
    position: absolute;
    bottom: 0;
    width: 45%;
}
.login__news__column {
    padding-top:50px;
    padding-left: 50px;
}
.login__news__title,
.login__form__title {
    font-size: 32px;
    text-align: center;
    overflow-wrap: normal;
    word-break: normal;
    hyphens: none;
}
.login__form__title h1 {
    font-size: 32px;
    font-weight: 500;
}

.login__news__title {
    margin-bottom: 32px;
    font-size: 55px;
	margin-top: 0px;
	padding-top: 0px;
    font-family: "Kanit", sans-serif !important;
}

.login__news__article__header::before {
    content: url('/login_news_bullet_point.svg');
}

.login__news__article__header {
    font-size: 24px;
    margin-bottom: 24px;
    line-height: 34px;
}

.login__news__article__text {
    font-size: 22px;
    font-weight: 300;
    line-height: 30px;
    color: #5C5C5C;
}

.login__news__article__spacing-hack {
    /* NO HAGÁIS ESTO EN CASA */
    height: 150px;
}
.card__signup__form {
    width: 100%;
    max-width: 450px;
}
.login__form__field {    
    margin: auto;
}
.login__form__title {
    font-size: 30px;
    margin-bottom: 20px;
    margin-top:20px;
    font-weight: 500;
}

@media screen and (max-width: 1264px) {   
    .hero__login .hero__login__container {
        padding-left: 0px;
        padding-right: 0px;
    }
    .login__news__title {
        margin-top: 18px;
        margin-bottom: 18px;
    }
    
    .login__form__column {
        margin-bottom: 16px;
        padding-left: 60px;
        padding-right: 60px;
        padding-bottom:60px;
    }
    .login__news__column {
        padding-top:20px;
        padding-left:60px;
        padding-right:60px;
    }
    .logo__login img {
        margin: 0;
    }
}
@media screen and (min-width: 600px) and (max-width: 960px){
    .login__news__title {
        font-size: 40px;
    }
    .logo__login img {
        margin: 0;
    }
}
@media screen and (max-width: 600px) {
    .login__form__column {
        padding-left: 25px;
        padding-right: 25px;
    }
    .login__news__column {        
        padding-left:25px;
        padding-right:25px;
    }
    .login__form__title {
        margin-top: 10px;
        margin-bottom: 24px;
        padding-top: 0px;
        font-size: 24px;
    }
    .login__form__title h1 {
        font-size: 24px;
    }

    .login__news__title {
        font-size: 26px;
    }
    .login__news__article__header {
        font-size: 20px;
        line-height: 30px;        
    }
    .login__news__article__text {
        font-size: 16px;    
    }
    .logo__login img {
        margin: 0;
    }
}

.white_dns {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

</style>
